import React from 'react';
import { DISCLAIMER } from '../data/gymklar';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-119" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-6xl" data-id="element-120" data-mp="3gh3q6bfwg0dk">
        <p className="font-serif text-3xl tracking-tight" data-id="element-121" data-mp="32onk11rpbm8f">
          GOLFKLAR<span className="align-super text-[0.5em]" data-id="element-122" data-mp="36pfsvtwnvp46">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-123" data-mp="36ppj9ilmbyae">
          GOLFKLAR™ er et selvstendig utviklet treningsmateriell for golftrenere. {DISCLAIMER}
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-124" data-mp="387ddgpep1cm">
          © 2026 GOLFKLAR™ · Edulabs Resources
        </p>
      </div>
    </footer>;
}